import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  topActionBar: {
    marginTop: '32px',
    marginBottom: '32px'
  },
  topActionDatepicker: {
    paddingRight: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      paddingRight: '0',
      paddingBottom: '10px',
      '& .MuiButton-root': {
        width: '100%'
      }
    }
  },
  topAction: {
    display: 'flex',
    '& .MuiButton-root': {
      width: '100%',
      minWidth: '100%'
    },
    '& .modal-trigger': {
      width: '100%'
    },
    [breakpointsFunc.breakpoints.down('lg')]: {
      '& .modal-trigger': {
        width: '100%'
      }
    }
  }
});
export default useStyles;